import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

const Error404 = () => (
	<>
		<Heading
			Tag="h1"
			sx={{ fontSize: "xl", fontColor: "3", textAlign: "center" }}
			spacing={{ mb: 6 }}
		>
			Not Found
		</Heading>
		<Paragraph sx={{ fontSize: "s", textAlign: "center" }}>
			We’re sorry. The requested resource was not found.
		</Paragraph>
	</>
);

export default Error404;
